import { createSelector } from 'reselect';
export const getFileUploadModalState = (state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.domain) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.fileUploadModal; };
export const isFileUploadModalOpen = createSelector([getFileUploadModalState], state => {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.isOpen) !== null && _a !== void 0 ? _a : false;
});
//# sourceMappingURL=isFileUploadModalOpen.js.map